export const heroStory = {
  slug: "wanghong-fanche-zhibo-jianjia",
  title: "千万粉丝网红直播翻车：假货风波持续发酵，品牌方连夜解约",
  excerpt: "拥有超过两千万粉丝的头部带货主播\"小美酱\"在昨晚直播中被网友实锤售卖假冒名牌护肤品，涉事品牌已紧急发布声明终止合作。这是本月第三起头部主播翻车事件，引发全网热议。",
  category: "网红翻车",
  categorySlug: "wanghong-fanche",
  imageUrl: "https://readdy.ai/api/search-image?query=Dramatic%20breaking%20news%20scene%20with%20a%20streaming%20studio%20setup%20featuring%20ring%20lights%20and%20a%20smartphone%20on%20a%20tripod%2C%20scattered%20luxury%20cosmetic%20products%20with%20red%20warning%20elements%2C%20dark%20and%20tense%20atmosphere%2C%20cinematic%20lighting%20with%20dramatic%20shadows%2C%20editorial%20photojournalism%20style%2C%20high%20contrast%2C%20warm%20amber%20and%20deep%20crimson%20tones%2C%20moody%20investigative%20aesthetic&width=1600&height=800&seq=hero-lead-2026-01&orientation=landscape",
  date: "2026-07-07",
  author: "吃瓜编辑部",
  readCount: 1283000,
  commentCount: 56241,
};

export const hotTopics = [
  {
    slug: "danghong-nanyixing-chugui",
    title: "当红男星深夜密会神秘女子，疑似婚内出轨",
    excerpt: "某知名男演员被拍到与一名年轻女子在酒店共度三小时，其经纪团队尚未回应。",
    category: "娱乐八卦",
    categorySlug: "yule-bagua",
    imageUrl: "https://readdy.ai/api/search-image?query=Paparazzi%20style%20night%20photography%20of%20a%20luxury%20hotel%20entrance%20at%20night%20with%20subtle%20silhouettes%2C%20mysterious%20and%20dramatic%20atmosphere%2C%20warm%20street%20lights%20reflecting%20on%20wet%20pavement%2C%20cinematic%20noir%20aesthetic%2C%20soft%20bokeh%20background%2C%20deep%20blues%20and%20amber%20tones%2C%20editorial%20gossip%20magazine%20vibe&width=800&height=560&seq=hot-topic-01&orientation=landscape",
    date: "2026-07-07",
    hotIndex: 98,
    readCount: 2456000,
  },
  {
    slug: "zhiming-zhubo-taoshui",
    title: "知名主播被曝偷税漏税，金额高达数千万",
    excerpt: "税务部门已介入调查，该主播名下多家公司被列入经营异常名录。",
    category: "社会热点",
    categorySlug: "shehui-redian",
    imageUrl: "https://readdy.ai/api/search-image?query=Corporate%20office%20scene%20with%20financial%20documents%20and%20a%20calculator%20on%20a%20dark%20wooden%20desk%2C%20dramatic%20overhead%20lighting%20creating%20harsh%20shadows%2C%20red%20seal%20stamps%20visible%20on%20papers%2C%20tense%20investigative%20mood%2C%20warm%20and%20cool%20color%20contrast%2C%20documentary%20style%20photography%2C%20high%20detail&width=800&height=560&seq=hot-topic-02&orientation=landscape",
    date: "2026-07-06",
    hotIndex: 95,
    readCount: 1987000,
  },
  {
    slug: "nvtuanti-yuan-neihong",
    title: "女团成员直播互撕，队内矛盾全面爆发",
    excerpt: "某当红女团两名成员在直播中公开争吵，互相指责对方耍大牌、抢资源。",
    category: "娱乐八卦",
    categorySlug: "yule-bagua",
    imageUrl: "https://readdy.ai/api/search-image?query=Split%20screen%20vibe%20with%20two%20contrasting%20sides%2C%20one%20side%20bright%20stage%20lights%20and%20glamorous%20atmosphere%2C%20other%20side%20dark%20backstage%20tension%2C%20music%20performance%20elements%20like%20microphones%20and%20spotlights%2C%20dramatic%20color%20contrast%20between%20warm%20gold%20and%20cool%20shadow%2C%20editorial%20entertainment%20news%20aesthetic&width=800&height=560&seq=hot-topic-03&orientation=landscape",
    date: "2026-07-06",
    hotIndex: 91,
    readCount: 1765000,
  },
  {
    slug: "daihuo-yige-baofa",
    title: "直播带货界大地震：多位大主播集体翻车",
    excerpt: "消费者协会发布最新检测报告，多款直播间热销产品被曝质量问题严重。",
    category: "独家爆料",
    categorySlug: "dujia-baoliao",
    imageUrl: "https://readdy.ai/api/search-image?query=Multiple%20smartphones%20displaying%20live%20streaming%20interfaces%20with%20shopping%20carts%2C%20arranged%20in%20a%20grid%20pattern%2C%20warning%20red%20accents%20on%20some%20screens%2C%20clean%20minimalist%20product%20photography%20style%2C%20soft%20diffused%20lighting%20from%20above%2C%20white%20and%20warm%20gray%20background%20with%20subtle%20red%20highlights&width=800&height=560&seq=hot-topic-04&orientation=landscape",
    date: "2026-07-05",
    hotIndex: 88,
    readCount: 1523000,
  },
  {
    slug: "yingshi-juxing-beiju",
    title: "影视巨星被曝片场耍大牌，导演愤然离场",
    excerpt: "据知情人士透露，该明星在拍摄现场多次迟到，还要求修改剧本，导致导演当场发飙。",
    category: "独家爆料",
    categorySlug: "dujia-baoliao",
    imageUrl: "https://readdy.ai/api/search-image?query=Film%20set%20environment%20with%20professional%20camera%20equipment%20and%20director%20chair%20empty%20in%20foreground%2C%20dramatic%20lighting%20rig%20overhead%2C%20tense%20atmosphere%20with%20warm%20cinematic%20lighting%2C%20clapperboard%20on%20the%20ground%20symbolizing%20disruption%2C%20behind%20the%20scenes%20documentary%20aesthetic&width=800&height=560&seq=hot-topic-05&orientation=landscape",
    date: "2026-07-05",
    hotIndex: 85,
    readCount: 1345000,
  },
  {
    slug: "wangluo-hongren-beipan",
    title: "网络红人被曝背后有资本操控，人设全面崩塌",
    excerpt: "一份内部文件曝光，揭示了该网红\"草根逆袭\"人设背后的资本运作真相。",
    category: "网红翻车",
    categorySlug: "wanghong-fanche",
    imageUrl: "https://readdy.ai/api/search-image?query=Behind%20the%20scenes%20office%20with%20documents%20scattered%20on%20a%20glass%20desk%2C%20a%20laptop%20screen%20glowing%20with%20data%20charts%2C%20dramatic%20side%20lighting%20casting%20long%20shadows%2C%20mysterious%20and%20investigative%20mood%2C%20warm%20amber%20and%20deep%20shadow%20tones%2C%20documentary%20photography%20style%2C%20cinematic%20composition&width=800&height=560&seq=hot-topic-06&orientation=landscape",
    date: "2026-07-04",
    hotIndex: 82,
    readCount: 1210000,
  },
];

export const categories = [
  {
    name: "网红翻车",
    slug: "wanghong-fanche",
    icon: "ri-alert-line",
    description: "直击各大网红直播翻车现场，还原真相",
    color: "primary",
    articleCount: 1280,
  },
  {
    name: "独家爆料",
    slug: "dujia-baoliao",
    icon: "ri-spy-line",
    description: "吃瓜一线独家内幕，行业黑幕大揭秘",
    color: "accent",
    articleCount: 965,
  },
  {
    name: "娱乐八卦",
    slug: "yule-bagua",
    icon: "ri-chat-smile-2-line",
    description: "娱乐圈最新动态，明星八卦一站掌握",
    color: "primary",
    articleCount: 2340,
  },
  {
    name: "社会热点",
    slug: "shehui-redian",
    icon: "ri-fire-line",
    description: "全网最热社会话题，深度分析解读",
    color: "accent",
    articleCount: 1560,
  },
];

export const comments = [
  {
    avatar: "https://readdy.ai/api/search-image?query=Professional%20headshot%20portrait%20of%20a%20young%20Chinese%20woman%2C%20neutral%20expression%2C%20clean%20white%20background%2C%20soft%20studio%20lighting%2C%20minimalist%20aesthetic&width=80&height=80&seq=avatar-user-01&orientation=squarish",
    username: "吃瓜不嫌事大",
    rating: 5,
    title: "太精彩了！这瓜保熟",
    content: "这个主播我早就觉得不对劲了，每次卖的货和专柜的完全不一样，终于翻车了！支持严查！",
    date: "2小时前",
  },
  {
    avatar: "https://readdy.ai/api/search-image?query=Professional%20headshot%20portrait%20of%20a%20young%20Chinese%20man%2C%20slight%20smile%2C%20clean%20white%20background%2C%20soft%20studio%20lighting%2C%20minimalist%20aesthetic&width=80&height=80&seq=avatar-user-02&orientation=squarish",
    username: "理性吃瓜人",
    rating: 4,
    title: "信息量很大，先收藏",
    content: "建议大家还是等官方通报出来再下结论，现在各种消息都在传，真假难辨。不过这个瓜确实有点大。",
    date: "3小时前",
  },
  {
    avatar: "https://readdy.ai/api/search-image?query=Professional%20headshot%20portrait%20of%20a%20young%20Chinese%20woman%20with%20glasses%2C%20thoughtful%20expression%2C%20clean%20white%20background%2C%20soft%20studio%20lighting%2C%20minimalist%20aesthetic&width=80&height=80&seq=avatar-user-03&orientation=squarish",
    username: "八卦小能手",
    rating: 5,
    title: "坐等后续更新",
    content: "品牌方都解约了，这基本实锤了吧？我现在就好奇还有多少品牌会跟着解约。这波打击不小啊。",
    date: "4小时前",
  },
  {
    avatar: "https://readdy.ai/api/search-image?query=Professional%20headshot%20portrait%20of%20a%20young%20Chinese%20man%20with%20casual%20style%2C%20confident%20look%2C%20clean%20white%20background%2C%20soft%20studio%20lighting%2C%20minimalist%20aesthetic&width=80&height=80&seq=avatar-user-04&orientation=squarish",
    username: "真相只有一个",
    rating: 4,
    title: "这个行业该整顿了",
    content: "直播带货行业确实太乱了，有关部门应该出台更严格的监管措施。消费者的权益谁来保护？",
    date: "5小时前",
  },
  {
    avatar: "https://readdy.ai/api/search-image?query=Professional%20headshot%20portrait%20of%20a%20young%20Chinese%20woman%20with%20warm%20smile%2C%20clean%20white%20background%2C%20soft%20studio%20lighting%2C%20minimalist%20aesthetic&width=80&height=80&seq=avatar-user-05&orientation=squarish",
    username: "甜甜的瓜",
    rating: 5,
    title: "本月的瓜一个比一个大",
    content: "七月才开始几天就已经这么多大瓜了，感觉今年夏天娱乐圈要炸！吃瓜群众表示很快乐。",
    date: "6小时前",
  },
  {
    avatar: "https://readdy.ai/api/search-image?query=Professional%20headshot%20portrait%20of%20a%20middle-aged%20Chinese%20man%2C%20serious%20expression%2C%20clean%20white%20background%2C%20soft%20studio%20lighting%2C%20minimalist%20aesthetic&width=80&height=80&seq=avatar-user-06&orientation=squarish",
    username: "行业观察者",
    rating: 4,
    title: "深度好文，值得思考",
    content: "从行业角度来看，这不仅仅是一个主播的问题，而是整个商业模式的问题。流量至上的时代该反思了。",
    date: "8小时前",
  },
];

export const trendingSidebar = [
  { rank: 1, title: "网红小美酱直播翻车全记录", slug: "wanghong-fanche-zhibo-jianjia", hotValue: "1283万" },
  { rank: 2, title: "当红男星深夜密会事件追踪", slug: "danghong-nanyixing-chugui", hotValue: "987万" },
  { rank: 3, title: "主播偷税漏税案最新进展", slug: "zhiming-zhubo-taoshui", hotValue: "876万" },
  { rank: 4, title: "女团内讧：谁才是真正的C位", slug: "nvtuanti-yuan-neihong", hotValue: "765万" },
  { rank: 5, title: "直播带货产品质量大调查", slug: "daihuo-yige-baofa", hotValue: "654万" },
  { rank: 6, title: "影视巨星片场风波后续", slug: "yingshi-juxing-beiju", hotValue: "543万" },
  { rank: 7, title: "网红人设崩塌背后的资本游戏", slug: "wangluo-hongren-beipan", hotValue: "432万" },
  { rank: 8, title: "某选秀冠军被曝学历造假", slug: "xuanxiu-guanjun-xueli", hotValue: "321万" },
];

export const navItems = [
  { label: "首页", href: "/" },
  { label: "51热榜", href: "/category/shehui-redian" },
  { label: "网红翻车", href: "/category/wanghong-fanche" },
  { label: "独家爆料", href: "/category/dujia-baoliao" },
  { label: "娱乐八卦", href: "/category/yule-bagua" },
];